import {Component, OnInit, ViewChild} from '@angular/core';
import {TableHeaderService} from '../../../resources/services/table-header.service';
import {FormService} from '../../../resources/services/form.service';
import {ActivatedRoute, Router} from '@angular/router';
import {ToastrService} from 'ngx-toastr';
import {Location} from '@angular/common';
import {StoreAppService} from '../../../resources/services/store-app.service';
import {finalize, take} from 'rxjs/operators';
import {PermissionService} from '../../../resources/services/permission.service';
import {BtnDeleteComponent} from '../../../resources/components/btn-delete/btn-delete.component';
import * as cloneDeep from 'lodash.clonedeep';
import {ActionService} from '../../../resources/services/action.service';
import {DeleteService} from '../../../resources/services/delete.service';

@Component({
  selector: 'store-edit',
  templateUrl: './store-edit.component.html'
})
export class StoreEditComponent implements OnInit {
  @ViewChild('btnDelete') private btnDelete: BtnDeleteComponent;

  item: any;

  id: any = this._route.parent.snapshot.params.id;
  initial: string;
  urlIndex: any;

  constructor(private tableHeaderService: TableHeaderService,
              private _formService: FormService,
              private _route: ActivatedRoute,
              private _toastr: ToastrService,
              private _location: Location,
              private permissionService: PermissionService,
              private _router: Router,
              private _modelService: StoreAppService,
              private deleteService: DeleteService) {
    this.urlIndex = this._router.createUrlTree(['../../../'], {relativeTo: this._route});
  }

  ngOnInit(): void {
    this.get();
  }

  ngOnDestroy() {
    // this.btnDelete.delete.pipe(take(1)).subscribe(() => {
    //   this.delete();
    // })
  }

  get(): void {
    let query = {
      id: this.id,
      relations: []
    };
    if (this.permissionService.get('StoreKeyComponent')) {
      query.relations.push('storeKey');
    }
    this._modelService.get(query)
      .subscribe((res: any) => {
          this.item = res;
          this.initial = this.item.name;
        },
        err => {
        }
      );
  }

  delete(item) {
    this._router.navigateByUrl(this.urlIndex);

    this.deleteService.process(item.type, item.name).then(() => {
      this._modelService.delete(this.id).subscribe();
    });
  }

  onSubmit(form) {
    setTimeout(() => {
      form.disable();
    });
    this._modelService.update(Object.assign({id: this.id}, form.value)).pipe(
      finalize(() => {
        this._router.navigate(['../../../'], {relativeTo: this._route});
      })
    ).subscribe();
  }

  back(e?: any) {
    if (e) {
      e.preventDefault();
    }

    this._location.back();
  }
}
